var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-curly-newline */
import React, { useCallback, useState, useEffect, useRef } from 'react';
import { ListGroup, ModalBody } from 'reactstrap';
import { SmlsInputText } from '../InputText';
import { SmlsModal } from '../Modal';
import { mapToCssModules } from '../../utils/className';
export const SmlsContact = ({ idPhoneNumber = '', isValidPhoneNumber, listCountries, headerTitle, idSearchDDI = '', idFlag = '', idErrorMsg = '', defaultCountryISO = 'BR', textLabel, className = '', notFoundMessage = 'Não encontramos nenhum resultado. Tente novamente', errorMessage, errorMessageDDD, onChange = () => undefined, onFocus, onBlur, isValid = () => undefined, defaultValue = '', maxLength = 19, value, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [countries, setCountries] = useState(listCountries);
    const [isFocused, setIsFocused] = useState(false);
    const [innerValue, setInnerValue] = useState('');
    const [isValidNumber, setIsValidNumber] = useState(false);
    const [countryISO2, setCountryISO2] = useState(defaultCountryISO);
    const [errorDDD, setErrorDDD] = useState(false);
    const [ddiSearchTerm, setDdiSearchTerm] = useState('');
    const [showFixedHeader, setShowFixedHeader] = useState(false);
    const enableOutline = useCallback(() => {
        if (onFocus)
            onFocus();
        setIsFocused(true);
    }, [onFocus]);
    const disableOutline = useCallback(() => {
        if (onBlur)
            onBlur();
        setIsFocused(false);
    }, []);
    const modalContentRef = useRef(null);
    const inputRef = useRef(null);
    useEffect(() => {
        var _a;
        if (!countries)
            return;
        const DDI = ((_a = countries.find((country) => country.iso2 === countryISO2)) === null || _a === void 0 ? void 0 : _a.ddi) || '';
        if (innerValue.split(' ')[1])
            return;
        setInnerValue(`+${DDI}`);
    }, [countryISO2]);
    useEffect(() => {
        setCountries(listCountries);
    }, [listCountries]);
    useEffect(() => {
        onChange(innerValue);
        isValid(isValidNumber);
    }, [isValidNumber, innerValue]);
    const handleFormat = useCallback((phone) => {
        let newPhone = phone;
        if (newPhone.match(/[^0-9-_ ()+]+/gi) || newPhone.length > 19)
            return;
        if (phone[0] !== '+' && phone.length >= 1) {
            const foundIso = countries.find((country) => country.iso2 === countryISO2);
            newPhone = `+${foundIso.ddi}${phone}`;
        }
        setInnerValue(newPhone);
        try {
            const { isValid: isValidPhone, DDD, DDI, nationalNumber, } = isValidPhoneNumber(newPhone);
            if ((DDI === null || DDI === void 0 ? void 0 : DDI.country) === 'BR') {
                const isValidDDD = Boolean(DDD === null || DDD === void 0 ? void 0 : DDD.isValid);
                setIsValidNumber(isValidPhone && isValidDDD);
                setErrorDDD(!isValidDDD);
            }
            else {
                setErrorDDD(false);
                setIsValidNumber(isValidPhone);
            }
            if (DDI === null || DDI === void 0 ? void 0 : DDI.country)
                setCountryISO2(DDI.country);
            if (nationalNumber && (DDI === null || DDI === void 0 ? void 0 : DDI.value))
                setInnerValue(`+${DDI === null || DDI === void 0 ? void 0 : DDI.value} ${nationalNumber}`);
        }
        catch (error) {
            setIsValidNumber(false);
        }
    }, [isValidPhoneNumber]);
    const handleChangeInput = useCallback((e) => {
        const phone = e.target.value;
        handleFormat(phone);
    }, [countryISO2, countries, isValidPhoneNumber]);
    const handleSearchChange = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        const text = e.target.value;
        const exp = new RegExp(text, 'ig');
        const filtered = listCountries.filter((country) => country.country.match(exp));
        setCountries(filtered);
        setDdiSearchTerm(text);
    }), [listCountries]);
    const handleDdiSelected = useCallback((country) => {
        if (countryISO2 !== country) {
            setInnerValue('');
            setCountryISO2(country);
            setIsValidNumber(false);
        }
        setIsOpen(false);
        setCountries(listCountries);
    }, [countryISO2, listCountries]);
    const handleOnModalClosed = useCallback(() => {
        setIsOpen(false);
        setDdiSearchTerm('');
        setCountries(listCountries);
    }, []);
    const handleScroll = useCallback(() => {
        const countriesLength = countries.length || 0;
        if (!modalContentRef.current)
            return;
        if (window.innerHeight / 80 > countriesLength) {
            setShowFixedHeader(false);
            return;
        }
        setShowFixedHeader(modalContentRef.current.getBoundingClientRect().y < -76);
    }, [countries]);
    useEffect(() => {
        var _a;
        (_a = document
            .querySelector('.contact-modal > div > div > .modal-body')) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', handleScroll);
        return () => {
            var _a;
            return (_a = document
                .querySelector('.contact-modal > div > div > .modal-body')) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);
    useEffect(() => {
        var _a;
        if (!showFixedHeader) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [showFixedHeader]);
    useEffect(() => {
        if (defaultValue && !(value === null || value === void 0 ? void 0 : value.length)) {
            try {
                const { isValid: isValidPhone, DDI, nationalNumber, } = isValidPhoneNumber(defaultValue);
                if (isValidPhone) {
                    setInnerValue(`+${DDI === null || DDI === void 0 ? void 0 : DDI.value} ${nationalNumber}`);
                    setErrorDDD(false);
                    setIsValidNumber(isValidPhone);
                }
            }
            catch (error) {
                //
            }
        }
    }, [isValidPhoneNumber]);
    useEffect(() => {
        if (value === null || value === void 0 ? void 0 : value.length) {
            handleFormat(value || '');
        }
    }, [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: mapToCssModules([
                'input-group',
                'input-contact',
                isFocused ? 'input-outline' : '',
                errorMessage && !isValidNumber && innerValue.length >= 7
                    ? 'error'
                    : '',
                className,
            ]) },
            React.createElement("label", { htmlFor: "input-text" }, textLabel),
            React.createElement("div", null,
                React.createElement("i", { id: idFlag, onClick: () => {
                        setIsOpen((prevState) => !prevState);
                    }, className: `smls-flags ${countryISO2.toLowerCase()}` }),
                React.createElement("input", { id: idPhoneNumber, value: innerValue, onChange: handleChangeInput, onFocus: enableOutline, onBlur: disableOutline, defaultValue: defaultValue, maxLength: maxLength })),
            React.createElement("div", { id: idErrorMsg, className: "input-error" }, errorMessage && !isValidNumber && innerValue.length >= 7 && (React.createElement(React.Fragment, null,
                React.createElement("i", { className: "material-icons" }, "error_outline"),
                React.createElement("label", { htmlFor: "input-text" }, errorDDD ? errorMessageDDD : errorMessage))))),
        React.createElement(SmlsModal, { isOpen: isOpen, onClosed: handleOnModalClosed, type: "right", className: "contact-modal", toggle: () => setIsOpen(false), defaultHeader: !showFixedHeader },
            showFixedHeader && (React.createElement("div", { className: "fixed-modal-header" },
                React.createElement(SmlsInputText, { id: idSearchDDI, placeholder: "Buscar seu pa\u00EDs", value: ddiSearchTerm, onChange: handleSearchChange, validate: () => true, regex: /[^0-9A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ .]+/g, maxLength: maxLength }),
                React.createElement("button", { type: "button", className: "smls-btn-close", "data-dismiss": "modal", "aria-label": "Close", onClick: () => setIsOpen(false) },
                    React.createElement("i", { className: "material-icons" }, "close")))),
            React.createElement(ModalBody, null,
                React.createElement("div", { ref: modalContentRef },
                    headerTitle && React.createElement("h3", null, headerTitle),
                    React.createElement(SmlsInputText, { id: idSearchDDI, placeholder: "Buscar seu pa\u00EDs", value: ddiSearchTerm, onChange: handleSearchChange, icon: React.createElement("i", { className: "material-icons" }, "search"), validate: () => true, innerRef: inputRef, regex: /[^0-9A-Za-záàâãéèêíïóôõöúüçñÁÀÂÃÉÈÍÏÓÔÕÖÚÜÇÑ .]+/g, maxLength: maxLength }),
                    React.createElement(ListGroup, null, countries === null || countries === void 0 ? void 0 : countries.map((country) => (React.createElement(React.Fragment, null,
                        React.createElement("li", { className: "list-group-item", id: `opt_${country.iso2}`, key: country.iso2, onClick: () => handleDdiSelected(country.iso2) },
                            React.createElement("i", { className: `smls-flags ${country.iso2.toLowerCase()}` }),
                            React.createElement("span", null,
                                React.createElement("b", null, `+${country.ddi}`),
                                ` ${country.country}`))))))),
                (!countries || !countries.length) && (React.createElement("div", { className: "country-not-found" },
                    React.createElement("p", null, notFoundMessage)))))));
};
//# sourceMappingURL=index.js.map